import $ from 'jquery';
import { trace } from 'rytm-helpers'

const scrollSpeed = 8000 // PX/sec
const scrollTimeOffset = 1 // PX/sec
// # get anchor link target element
const getAnchorLinkTarget = (trigger) => {
  const targetSelector = trigger.getAttribute("href")
  if (targetSelector) {
    const id = targetSelector.substring(1)
    return document.getElementById(id)
  }
}
// # Distance (PX) to target
const getDistanceToTarget = (target) => {
  const targetTop = target.offsetTop
  return Math.round(Math.abs(window.pageYOffset - targetTop))
}
// # Time of scroll to target animation
const getScrollToTargetTime = (target) => {
  const distance = getDistanceToTarget(target)
  return scrollTimeOffset + distance / scrollSpeed
}
const getWindowScrollTop = () => {
  const doc = document.documentElement
  return (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0)
}
const getTargetTopScrollPos = (target) => {
  // return target.offsetTop
  const rect = target.getBoundingClientRect()
  return rect.top + getWindowScrollTop()
}
// # go to target 
export const scrollToTarget = (target, offset = 0, callback = null, myTime = null) => {
  const targetTop = getTargetTopScrollPos(target) + offset
  const time = myTime ? myTime : getScrollToTargetTime(target)
  // trace("***** scroll to target, time", time)
  doScrolling(targetTop, time)
  // TweenMax.to(window, time, {scrollTo: {y: targetTop}, ease: Power3.easeInOut, onComplete: callback});
}

const onScrollToClick = (e) => {
  e.preventDefault();
  const trigger = e.currentTarget
  const target = getAnchorLinkTarget(trigger)
  if (target) {
    let offset = trigger.dataset.offset ? parseInt(trigger.dataset.offset) : 0
    if (offset == 0) {
      // check header
      const header = document.querySelector(".header-full-inner")
      if (header && getComputedStyle(header).position == 'fixed') {
        offset = - header.offsetHeight
      } 
    }
    scrollToTarget(target, offset)
  }
}

const doScrolling = (elementY, duration) => { 
  var startingY = window.pageYOffset;
  var diff = elementY - startingY;
  var start;

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp;
    // Elapsed milliseconds since start of scrolling.
    var time = timestamp - start;
    // Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1);

    window.scrollTo(0, startingY + diff * percent);

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step);
    }
  })
}

export const initScrollTo = () => {
  $('body').on('click', '.scroll-to', onScrollToClick);
}